// Native
import { useQueryClient } from "@tanstack/react-query"
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Divider, List, ListIcon, ListItem, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Dialog, Form, Show } from "components"
import { TbReportMoney, TbCreditCard, TbNotification } from 'react-icons/tb'

// Config
import { API } from "config"

// Hooks
import { useOrder } from "hooks"

// Screens
import { Authenticate } from "screens"

export default function Cancel({ data, ...props }){

    const toast = useToast()
    const queryClient = useQueryClient()
    const order = useOrder(data?.id)
    const [ reason, setReason ] = useState()
    const [ loading, setLoading ] = useState(false)
    const authenticate = useDisclosure()
    const isEnabled = reason?.length >= 5

    const handleCancel = async () => {
        if(!isEnabled) return
        setLoading(true)

        try{
            await API.put(`/orders/${order.data.id}/cancel`, { canceled_reason: reason })
            toast({ title: 'O pedido foi cancelado', status: 'info' })
            queryClient.invalidateQueries('orders')
            setReason(null)
            order.refetch()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível cancelar o pedido.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return (
    <>
    <Dialog title={`Cancelar pedido #${order.data?.cod}`} loading={loading} {...props}>
        <AlertDialogBody fontSize="sm">
            Você está prestes a cancelar um pedido. Esta ação é definitiva e irreversível. Tenha em mente os efeitos colaterais ao realizar 
            o cancelamento de um pedido:
            <br />

            <Show visible={!order.data?.is_matriz}>
                <Alert status="warning" title="Você está cancelando um pedido de núcleo" my={4}>
                    Tenha em mente que este é um pedido de um núcleo de distribuição <b>{order.data?.distributor_from?.name}</b> e não da matriz ou filiais. Portanto, garanta autorização expressa para realizar esta ação.
                </Alert>
            </Show>

            <br />
            <b>O que acontece ao cancelar um pedido?</b>
            <br />

            <List spacing={3} p={4} fontSize="xs">
                <ListItem><ListIcon as={TbReportMoney} color="orange" />Pagamentos realizados com bônus serão removidos do núcleo em questão e retornados ao escritório do consultor;</ListItem>
                <ListItem><ListIcon as={TbCreditCard} color="orange" />Pagamentos realizados via pix ou cartão de crédito terão de ser estornados manualmente;</ListItem>
                <ListItem><ListIcon as={TbCreditCard} color="orange" />Pontuação e bonificação gerada para este pedido será removida para toda a rede;</ListItem>
                <ListItem><ListIcon as={TbNotification} color="orange" />Produtos reservados no estoque do núcleo ficarão disponíveis novamente;</ListItem>
                <ListItem><ListIcon as={TbNotification} color="orange" />O cliente e núcleo serão notificados do cancelamento;</ListItem>
            </List>

            <Divider my={4} />

            <Form.Textarea
                size="sm"
                label="Motivo do cancelamento:"
                placeholder="Ex.: O pedido foi cancelado por..."
                helper="O motivo do cancelamento é obrigatório e deve ser detalhado."
                value={reason}
                onChange={e => setReason(e.target.value)}
                isDisabled={loading}
            />

            
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button variant="ghost" children="Sim, desejo cancelar" isDisabled={!isEnabled} isLoading={loading} loadingText="Cancelando pedido..." onClick={authenticate.onOpen} />
                <Button variant="ghost" colorScheme="red" children="Fechar" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>

    <Authenticate {...authenticate} onSuccess={handleCancel} />
    </>
    )
}